import React, { useState } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import FormModal from "../../../components/FormModal";
import { createProject } from "./SkeyecubeProjectsAPI";
import { extractMsg } from "../../../utils/errorUtils";

export default function SkeyecubeAddProjectDialog({
  open,
  onClose,
  onSuccess,
  messageApi,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      const propertiesObject = {};
      if (values.properties?.length > 0) {
        values.properties.forEach(({ key, value }) => {
          if (key && value) propertiesObject[key] = value;
        });
      }
      await createProject({
        projectName: values.projectName,
        description: values.description,
        properties: propertiesObject,
      });
      messageApi.success("Project successfully created.");
      form.resetFields();
      onSuccess();
      onClose();
    } catch (error) {
      messageApi.error({
        content: extractMsg(error, "Failed to create project"),
        key: "create-error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormModal
      title="Create New Skeyecube Project"
      open={open}
      onClose={() => {
        form.resetFields();
        onClose();
      }}
      onFinish={handleFinish}
      loading={loading}
      form={form}
      submitText="Create Project"
      width={600}
    >
      <Form.Item
        name="projectName"
        label="Project Name"
        rules={[{ required: true, message: "Please input the project name!" }]}
      >
        <Input placeholder="Enter project name" />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea rows={3} placeholder="Enter description" />
      </Form.Item>
      <div style={{ marginBottom: "16px", fontWeight: 500 }}>
        Properties (Optional)
      </div>
      <Form.List name="properties">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Row
                key={key}
                gutter={16}
                align="middle"
                style={{ marginBottom: 8 }}
              >
                <Col span={10}>
                  <Form.Item
                    {...restField}
                    name={[name, "key"]}
                    rules={[{ required: true, message: "Missing key" }]}
                    style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="Key" />
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item
                    {...restField}
                    name={[name, "value"]}
                    rules={[{ required: true, message: "Missing value" }]}
                    style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="Value" />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <MinusCircleOutlined
                    onClick={() => remove(name)}
                    style={{ color: "#d9363e", fontSize: "16px" }}
                  />
                </Col>
              </Row>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Add Property
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </FormModal>
  );
}
